module.exports = __webpack_public_path__ + "img/31.c623c741.jpg";